export default __webpack_public_path__ + "static/play-d3543c814b0cd392e140ec4e07be625b.png";